import React, { ReactElement } from 'react';

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import {
  ToolTipContent,
  ToolTipName,
} from '@/components/Approval/RightContainer/ApprovalContent/AuthorTooltip/styles';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

type P = {
  name: string;
  placeName: string;
  departmentName: string;
  children: ReactElement<any, any>;
};

const AuthorTooltip = ({ name, placeName, departmentName, children }: P) => {
  return (
    <BootstrapTooltip
      title={
        <div>
          <ToolTipName>{name}</ToolTipName>
          <ToolTipContent>{placeName}</ToolTipContent>
          <ToolTipContent>{departmentName}</ToolTipContent>
        </div>
      }
      placement={'top'}
    >
      {children}
    </BootstrapTooltip>
  );
};

export default AuthorTooltip;
